module.exports = __webpack_public_path__ + "static/media/icon-unselect.caab0d66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-unselect.svg
// module id = 1611
// module chunks = 0